import { render, staticRenderFns } from "./SurveyBuilder.vue?vue&type=template&id=550c513b&scoped=true&"
import script from "./SurveyBuilder.vue?vue&type=script&lang=js&"
export * from "./SurveyBuilder.vue?vue&type=script&lang=js&"
import style0 from "./SurveyBuilder.vue?vue&type=style&index=0&id=550c513b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550c513b",
  null
  
)

export default component.exports